import { LinkLabel } from '@/commons/tableFields';
import { CONSTANT_TABLE } from '@/components/Table/list-table/interface';
import { PATH_DASHBOARD, path } from '@/routes/paths';
import { formatDateWithTime, parseUserDate, translates } from '@/utils';
import { currentFormat } from '@/utils/cases';
import { commonTableDateFormat } from '@/utils/constants';
import { Chip } from '@mui/material';

export const TABLE_HEAD_CASH_REGISTER: CONSTANT_TABLE[] = [
  {
    id: 'id',
    label: 'ID',
    align: 'left',
    wrapComponent: (value: string) => (
      <LinkLabel value={value} to={PATH_DASHBOARD['cash-register'].view(value)} />
    ),
  },
  { id: 'actmUserOpen.name', label: translates.atmOpen, align: 'left' },
  { id: 'actmUserCloseId.name', label: translates.atmClose, align: 'left' },

  {
    id: 'initialCash',
    label: translates.initialCash,
    align: 'center',
    wrapComponent: (value: number) => currentFormat(value),
  },
  {
    id: 'createdAt',
    label: translates.createdAt,
    align: 'center',
    wrapComponent: (date) => formatDateWithTime(date),
  },
  {
    id: 'finalCash',
    label: translates.finalCash,
    align: 'center',
    wrapComponent: (value: number) => currentFormat(value),
  },
  { id: 'closeRegister', label: translates.closedAt, align: 'center',
  wrapComponent: (date) => date ? formatDateWithTime(date): '',
},
  { id: 'comment', label: translates.observation, align: 'center' },
  {
    id: 'closeValidate',
    label: translates.mismatch,
    align: 'center',
    wrapComponent: (value: boolean) => (
      <Chip
        color={value ? 'success' : 'error'}
        label={value ? translates.consistent : translates.inconsistent}
      />
    ),
  },
  {
    id: 'difference',
    label: translates.diference,
    align: 'center',
    wrapComponent: (value: number) => currentFormat(value),
  },
  {
    id: 'isOpen',
    label: translates.status,
    align: 'center',
    wrapComponent: (value: boolean) => (
      <Chip
        color={value ? 'success' : 'error'}
        label={value ? translates.open : translates.closed}
      />
    ),
  },
  { id: '', disableSort: true },
];

export const STATUS_OPTIONS = [
  { value: 'true', label: translates.open },
  { value: 'false', label: translates.closed },
];

export const PATH_RESERVATION = (ROOTS_DASHBOARD: string) => ({
  root: path(ROOTS_DASHBOARD, '/cash-register'),
  list: path(ROOTS_DASHBOARD, '/cash-register/list'),
  view: (name: number) => path(ROOTS_DASHBOARD, `/cash-register/${name}`),
  edit: (name: number) => path(ROOTS_DASHBOARD, `/cash-register/${name}/edit`),
});
